<div class="coming scroll">
  <div class="page-wrap">
    <div class="page-header">
      <img src="teaser/img/okito-logo.png" alt="Okito">
    </div>

    <div class="page-body">
      <h2>May <span>Padating!</span></h2>
      <h4>Okay sa sakay, Okay sa hatid, Okay sa kita!</h4>
      <a href="https://partner.okito.ph" class="cta-button" target="_blank" rel="noopener">Become a Partner <img src="teaser/img/arrow-up-right.svg" alt=""></a>
      <img src="teaser/img/img-left.png" class="tag" alt="">
      <img src="teaser/img/img-right.png" class="star" alt="">
    </div>

    <div class="header-img">
      <img src="teaser/img/okito_girl.png" class="absolute" alt="">
    </div>

    <div class="bg-content">
      <h3>Join our community!</h3>
      <div class="social-cards">
        <a href="https://www.facebook.com/OkitoPH/" class="social-card" target="_blank" rel="noopener">
          <span class="card-icon fb-icon"><img src="teaser/img/fb.svg" alt=""></span>
          <span class="card-info">
            <strong>Okito Philippines</strong>
            <small>&#64;OkitoPH · Facebook</small>
          </span>
          <img src="teaser/img/arrow-up-right.svg" class="card-arrow" alt="">
        </a>
        <a href="https://www.instagram.com/okitoph" class="social-card" target="_blank" rel="noopener">
          <span class="card-icon ig-icon"><img src="teaser/img/ig.svg" alt=""></span>
          <span class="card-info">
            <strong>Okito PH</strong>
            <small>&#64;okitoph · Instagram</small>
          </span>
          <img src="teaser/img/arrow-up-right.svg" class="card-arrow" alt="">
        </a>
        <a href="https://www.facebook.com/OkitoRiders/" class="social-card" target="_blank" rel="noopener">
          <span class="card-icon fb-icon"><img src="teaser/img/fb.svg" alt=""></span>
          <span class="card-info">
            <strong>Okito Riders</strong>
            <small>&#64;OkitoRiders · Facebook</small>
          </span>
          <img src="teaser/img/arrow-up-right.svg" class="card-arrow" alt="">
        </a>
        <a href="https://www.facebook.com/groups/okitoriders" class="social-card" target="_blank" rel="noopener">
          <span class="card-icon group-icon"><img src="teaser/img/users.svg" alt=""></span>
          <span class="card-info">
            <strong>Okito Riders Community</strong>
            <small>Facebook Group</small>
          </span>
          <img src="teaser/img/arrow-up-right.svg" class="card-arrow" alt="">
        </a>
      </div>
    </div>

    <div class="page-footer">
      <img src="teaser/img/okito-logo-white.png" class="footer-logo" alt="Okito">
      <p>© 2026 Ok!to. All rights reserved.</p>
    </div>
  </div>
</div>
